import { useState, useEffect } from "react";
import { CustomText, Input, InputDate } from "../../../../../components";
import { fonts } from "../../../../../config";

import { masks, validations } from "../../../../../utils";
import { StylesForm } from "../../../styles";
import { Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";

interface ICompanion {
  name?: string;
  email?: string;
  birthDate?: string;
  phone?: string;
  cpf?: string;
}

interface ICompanionFormProps {
  companion?: ICompanion;
  fileName: any;
  index: number;
  handleImageChange: (index?: number) => void;
  openModalViewImg: (data: { name: string; src: string }) => void;
  fileRef: any;
  updateIsUnderAge: (index: number, isUnderAge: boolean) => void;
}

export function CompanionForm({
  companion,
  fileName,
  index,
  handleImageChange,
  openModalViewImg,
  fileRef,
  updateIsUnderAge
}: ICompanionFormProps) {
  const [birthDate, setBirthdate] = useState(companion?.birthDate || "");
  const [isUnderAge, setIsUnderAge] = useState(false);

  useEffect(() => {
    if (birthDate) {
      const age = calculateAge(birthDate);
      setIsUnderAge(age < 15);

      if (age < 15 && fileName["other-" + index]) {
        handleImageClear();
      }
    }
  }, [birthDate, fileName]);

  const calculateAge = (date) => {
    const birthDate = new Date(date);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleImageClear = () => {
    // Limpar o campo de imagem
    fileRef.current[`other-${index}`] = null;
    // Atualizar o estado do nome do arquivo
    fileName["other-" + index] = "";
  };

  return (
    <>
      <CustomText
        style={{ paddingBottom: "25px" }}
        fontSize={1.75}
        fontFamily={fonts.bold}
        textColor="#8D9B9C"
      >
        ACOMPANHANTE #{index + 1}
      </CustomText>
      <Grid alignItems="flex-start" container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            validation={validations.isValidFullname}
            label="NOME COMPLETO"
            name={"fullName" + index}
            defaultValue={companion?.name}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            validation={validations.validateCPF}
            mask={masks.CPF}
            label="CPF"
            name={"cpf" + index}
            maskToSubmit={masks.removeNumberMask}
            defaultValue={companion?.cpf}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <InputDate
            maxDate={new Date()}
            label="DATA NASCIMENTO"
            name={"birthday" + index}
            defaultValue={
              companion?.birthDate &&
              masks.formatInputDate(companion?.birthDate)
            }
            onChange={(date: string) => {
              setBirthdate(date);
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            validation={validations.isEmailValid}
            label="E-MAIL"
            name={"email" + index}
            defaultValue={companion?.email}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            mask={masks.inputMaskTELWithDDD}
            label="TELEFONE"
            maskToSubmit={masks.removeNumberMask}
            name={"phone" + index}
            defaultValue={companion?.phone}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <CustomText
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            CADASTRO DA FACIAL**
          </CustomText>
          <StylesForm.InputImage style={{ opacity: isUnderAge ? 0.5 : 1 }}>
            <StylesForm.InputImageClick
              onClick={(event) => {
                if (Boolean(fileName["other-" + index]) || isUnderAge) {
                  event.preventDefault();
                }
              }}
              htmlFor={"fileInput" + index}
            >
              {Object.keys(fileName).find((a) => a === "other-" + index) &&
              fileName["other-" + index] ? (
                <CustomText
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    display: "block"
                  }}
                  textColor="#4D585A"
                  fontSize={2}
                  fontFamily={fonts.medium}
                >
                  {fileName["other-" + index]}
                </CustomText>
              ) : (
                <CustomText
                  textColor="#4D585A"
                  fontSize={2}
                  fontFamily={fonts.medium}
                >
                  Clique aqui para cadastrar facial
                </CustomText>
              )}
              <button
                id={"fileInput" + index}
                onClick={() => !isUnderAge && handleImageChange(index)}
                style={{ display: "none" }}
              ></button>
            </StylesForm.InputImageClick>

            {Boolean(fileName["other-" + index]) && (
              <StylesForm.InputView
                endIcon={<Visibility />}
                fullWidth={false}
                onClick={() =>
                  openModalViewImg({
                    name: fileName["other-" + index],
                    src: fileRef.current[`other-${index}`]
                  })
                }
              >
                Visualizar
              </StylesForm.InputView>
            )}
          </StylesForm.InputImage>
        </Grid>
      </Grid>
    </>
  );
}
